/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import { Component, OnDestroy, OnInit } from '@angular/core';

import { AppUtilityService } from '../../core/services/app-utility.service';
import { ConfigService } from './../../core/services/config.service';
import { EditModeService } from '../../core/services/edit-mode.service';
import { LmsBaseAppComponent } from '../../core/component/base-app/lms-base-app.component';
import { LmsLoaderService } from '../../core/services/lms-loader.service';
import { LmsMenuService } from './../../core/services/lms-menu.service';
import { LmsModuleService } from './../../core/services/lms-module.service';
import { LocoDetail } from '../../core/model/loco-detail.model';
import { MessageDetails } from '../../core/model/message-details.model';
import { MessageHandlerService } from '../../core/services/message-handler.service';
import { PopupService } from '../../core/services/popup.service';
import { RouteChangePopupService } from '../../core/services/route-change-popup.service';
import { TrainProfileCalculatedTonnage } from '../../core/model/train-profile-calculated-tonnage';
import { TrainProfileService } from './../services/train-profile.service';
import { UtilService } from './../../core/services/util.service';
import { PermitAll } from '@csx/security';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map, switchMap } from 'rxjs/operators';

/**
 * @export
 * @class LmsTrainProfileComponent
 * @extends {LmsBaseAppComponent}
 * @implements {OnInit}
 */
@Component({
  selector: 'lms-train-profile',
  templateUrl: './train-profile.component.html',
  styleUrls: ['./train-profile.component.scss']
})
@PermitAll()
export class LmsTrainProfileComponent extends LmsBaseAppComponent implements OnInit, OnDestroy {


  subTypes: string[]; // To be passed in Top Action
  exColLabel: string; // Expand Collapse Label
  exColLabelSign: string; // Expand Collapse Label Sign
  calculatorHeading: string; // Heading shown when calculator is clicked
  valuesToBeAddedInCalculation: Array<string> = []; // Values which are used to calculat Tonnage Capacity
  isTonnageCapacityShown: boolean; // This tells whether Tonnage capacity column is shown or not
  isTreeOpen: boolean; // This checks whether all tree is open or not
  profileLabel: any; // Label File
  tabLevel: number;
  calculationList: Array<LocoDetail> = []; // Values sent for Request
  tonnageData: TrainProfileCalculatedTonnage; // Tonnage Data Response Model

  /**
   * Creates an instance of LmsTrainProfileComponent.
   * @param {TrainProfileService} trainProfileService
   * @param {AppUtilityService} appUtilityService
   * @param {LmsModuleService} lmsModuleService
   * @param {ConfigService} configService
   * @param {LmsMenuService} lmsMenuService
   * @param {UtilService} utilService
   * @param {EditModeService} editModeService
   * @param {RouteChangePopupService} routerChangePopUpService
   * @param {PopupService} popupService
   * @memberof LmsTrainProfileComponent
   */
  constructor(private trainProfileService: TrainProfileService, 
              private appUtilityService: AppUtilityService, 
              lmsModuleService: LmsModuleService,
              configService: ConfigService,
              lmsMenuService: LmsMenuService,
              utilService: UtilService,
              editModeService: EditModeService,
              routerChangePopUpService: RouteChangePopupService, 
              popupService: PopupService, 
              private lmsLoaderService: LmsLoaderService, 
              private messageHandlerService: MessageHandlerService) 
    {
    super(configService, lmsMenuService, lmsModuleService, utilService, editModeService, routerChangePopUpService, popupService);
    this.service = this.trainProfileService;
    this.type = this.configService.getConfigData().menu.type.train;
    this.tabLevel = this.configService.getConfigData().tabIndex.subTabs;
    this.profileLabel = this.configService.getConfigData().trainProfileLabel;
  }

  /**
   * @memberof LmsTrainProfileComponent
   */
  ngOnInit() {
    super.init(this.search);
    this.isTonnageCapacityShown = false;
    this.exColLabel = this.profileLabel.expandAll;
    this.exColLabelSign = this.profileLabel.plus;
  }



  /**
   * This method is called when we click on Calculator and it starts calculation of Tonnage Capacity
   * @memberOf LmsTrainProfileComponent
   */
  public showTonnageCapacityCalculation() {
    if (this.isTonnageCapacityShown) {
      this.isTonnageCapacityShown = false;
    } else {
      this.isTonnageCapacityShown = true;
    }
    this.clearAllCalulatedValue();
  }


  /**
   * This method is used to Expand all or Collapse all the complete Tree
   * @memberOf LmsTrainProfileComponent
   */
  public expandCollapseTree() {
    if (this.loadData && this.loadData.profileData && this.loadData.profileData.length > 0) {
      for (const lmsLevel of this.loadData.profileData) {
        lmsLevel.expanded = this.profileLabel.expandAll === this.exColLabel ? true : false;
        if (lmsLevel.children && lmsLevel.children.length > 0) {
          for (const profileLevel of lmsLevel.children) {
            profileLevel.expanded = this.profileLabel.expandAll === this.exColLabel ? true : false;
          }
        }
      }
      if (this.profileLabel.expandAll === this.exColLabel) {
        this.exColLabel = this.profileLabel.collapseAll;
        this.exColLabelSign = this.profileLabel.minus;
      } else {
        this.exColLabel = this.profileLabel.expandAll;
        this.exColLabelSign = this.profileLabel.plus;
      }

      this.loadData.profileData = [ ...this.loadData.profileData ];
    }
  }

  /**
   * This method is called when we manually open a partiular tree Child
   * @memberOf LmsTrainProfileComponent
   */
  public openNode() {
    setTimeout(() => {
      this.isTreeOpen = false;
      if (this.loadData && this.loadData.profileData && this.loadData.profileData.length > 0) {
        for (const lmsLevel of this.loadData.profileData) {
          if (!lmsLevel.expanded) {
            this.isTreeOpen = true;
            break;
          }
          if (lmsLevel.children && lmsLevel.children.length > 0) {
            for (const profileLevel of lmsLevel.children) {
              if (!profileLevel.expanded) {
                this.isTreeOpen = true;
                break;
              }
            }
          }
          if (this.isTreeOpen) {
            break;
          }
        }
        if (!this.isTreeOpen) {
          this.exColLabel = this.profileLabel.collapseAll;
          this.exColLabelSign = this.profileLabel.minus;
        }
      }
    }, 100);
  }

  /**
    * This method is called when we manually close a partiular tree Child
    * @memberOf LmsTrainProfileComponent
    */
  public closeNode() {
    this.exColLabel = this.profileLabel.expandAll;
    this.exColLabelSign = this.profileLabel.plus;
  }


  /**
   * Remove error when error message is closed
   * @param {any} event
   * @memberOf LmsTrainProfileComponent
   */
  public clearErrorMessage(event) {
    this.selectedTab.subTypeDetail.profile.message = this.profileLabel.blank;
    this.lmsModuleService.updateSelectedTab(this.selectedTab);
  }

  /**
   * Calculate Tonnage Capacity Value based on columns selected by User
   * @param {string} label
   * @memberOf LmsTrainProfileComponent
   */
  public addColumnsNeededToCalculateTonnageCapacity(label: string) {
    if (this.valuesToBeAddedInCalculation && this.valuesToBeAddedInCalculation.length < 15) {
      this.valuesToBeAddedInCalculation.push(label);
      this.showCalculateTonnageCapacityHeader();
      if (this.calculatorHeading) {
        this.calculatorHeading = this.calculatorHeading.substring(0, this.calculatorHeading.length - 2);
      }
      this.calculateAndShowTonnageCapacity();
    }
  }

  /**
   * This method clears all the calculation used to calculate Tonnage Capacity value
   * @memberOf LmsTrainProfileComponent
   */
  public clearAllCalulatedValue() {
    this.calculatorHeading = this.profileLabel.blank;
    this.valuesToBeAddedInCalculation = [];
    this.calculationList = [];
    this.tonnageData = {};
    this.clearTonnageCapacityValue();
  }

  /**
   * This method clears previous calculation of Tonnage Capacity
   * @memberOf LmsTrainProfileComponent
   */
  public clearPreviousCalulationValue() {
    if (this.valuesToBeAddedInCalculation && this.valuesToBeAddedInCalculation.length > 0) {
      this.valuesToBeAddedInCalculation = this.valuesToBeAddedInCalculation.slice(0, -1);
      this.showCalculateTonnageCapacityHeader();
      this.calculatorHeading = this.calculatorHeading.substring(0, this.calculatorHeading.length - 2);
      if (this.valuesToBeAddedInCalculation && this.valuesToBeAddedInCalculation.length > 0) {
        this.calculateAndShowTonnageCapacity();
      } else {
        this.clearAllCalulatedValue();
      }
    }
  }

  /**
   * This method is used to show which columns are used in calculation to calculate Tonnage Capacity
   * @memberOf LmsTrainProfileComponent
   */
  private showCalculateTonnageCapacityHeader() {
    if (this.valuesToBeAddedInCalculation && this.valuesToBeAddedInCalculation.length > 0) {
      this.calculatorHeading = this.profileLabel.blank;
      for (const label of this.valuesToBeAddedInCalculation) {
        this.calculatorHeading += label + this.profileLabel.blankSpace + this.profileLabel.plus + this.profileLabel.blankSpace;
      }
    }
  }

  /**
   * This is search Method used to search Train Profile Data
   * @memberOf LmsTrainProfileComponent
   */
  public search() {
    this.trainProfileService.load(this.selectedTab);
    this.exColLabel = this.profileLabel.expandAll;
    this.exColLabelSign = this.profileLabel.plus;
    this.isTonnageCapacityShown = false;
    this.clearAllCalulatedValue();
  }

  /**
   * This method clears the tonnage Capacity Value which is calculated
   * @memberOf LmsTrainProfileComponent
   */
  private clearTonnageCapacityValue() {
    if (this.loadData && this.loadData.profileData && this.loadData.profileData.length > 0) {
      for (const lmsLevel of this.loadData.profileData) {
        lmsLevel.data.tonnageCapacity = this.profileLabel.blank;
        if (lmsLevel.children && lmsLevel.children.length > 0) {
          for (const profileLevel of lmsLevel.children) {
            profileLevel.data.tonnageCapacity = this.profileLabel.blank;
            if (profileLevel.children && profileLevel.children.length > 0) {
              for (const gradeLevel of profileLevel.children) {
                gradeLevel.data.tonnageCapacity = this.profileLabel.blank;
              }
            }
          }
        }
      }
    }
  }

  /**
   * This method is used to change the label to Field to calculate Tonnage Capacity
   * @param {string} value
   * @returns {string}
   * @memberOf LmsTrainProfileComponent
   */
  private changeLabelToField(value: string): string {
    let field = this.profileLabel.blank;
    switch (value) {
      case this.profileLabel.A:
        field = this.profileLabel.category0;
        break;
      case this.profileLabel.B:
        field = this.profileLabel.category1;
        break;
      case this.profileLabel.C:
        field = this.profileLabel.category2;
        break;
      case this.profileLabel.D:
        field = this.profileLabel.category3;
        break;
      case this.profileLabel.E:
        field = this.profileLabel.category4;
        break;
      case this.profileLabel.F:
        field = this.profileLabel.category5;
        break;
      case this.profileLabel.G:
        field = this.profileLabel.category6;
        break;
      case this.profileLabel.H:
        field = this.profileLabel.category7;
        break;
      case this.profileLabel.I:
        field = this.profileLabel.category8;
        break;
    }
    return field;
  }


  /**
   * Generate Request for Tonnage Service
   * @memberof LmsTrainProfileComponent
   */
  generateRequestList() {
    if (this.valuesToBeAddedInCalculation && this.valuesToBeAddedInCalculation.length > 0) {
      const count = {};
      this.valuesToBeAddedInCalculation.forEach((i) => { count[i] = (count[i] || 0) + 1; });
      for (const key of Object.keys(count)) {
        const data = {
          tonnageCategory: this.changeLabelToField(key),
          count: count[key]
        };
        this.calculationList.push(data);
      }
    }
  }
  /**
   * This method performs all the calculations to be done for tonnage capacity
   * @memberOf LmsTrainProfileComponent
   */
  private calculateAndShowTonnageCapacity() {
    if (this.loadData && this.loadData.profileData && this.loadData.profileData.length > 0) {
      this.tonnageData = {};
      this.calculationList = [];
      this.lmsLoaderService.showLoader();
      this.generateRequestList();
      this.trainProfileService.calculateTonnageCapacity(this.selectedTab.tabSearchParameter.searchText, this.calculationList).subscribe(
        (data) => {
          this.calculateTonnageSubscribe(data);
        }, error => {
          this.calculateTonnageError(error);
        });
    }
  }


  /**
   * Subscribe method for tonnage Capacity
   * @private
   * @param {*} data
   * @memberof LmsTrainProfileComponent
   */
  private calculateTonnageSubscribe(data: any) {
    this.tonnageData = data;
    for (const lmsLevel of this.loadData.profileData) {
      lmsLevel.data.tonnageCapacity = this.profileLabel.blank;
      if (this.tonnageData && this.tonnageData.lmsList && this.tonnageData.lmsList.length > 0) {
        for (const lmsData of this.tonnageData.lmsList) {
          if (lmsLevel.data.arriveMnemonic.trim() === lmsData.arriveMnemonic.trim() && lmsLevel.data.departMnemonic.trim() === lmsData.departMnemonic.trim()) {
            lmsLevel.data.tonnageCapacity = Number(lmsData.calculatedTonnageRating);
          }
        }
      }
      if (lmsLevel.children && lmsLevel.children.length > 0) {
        for (const profileLevel of lmsLevel.children) {
          profileLevel.data.tonnageCapacity = this.profileLabel.blank;
          if (this.tonnageData && this.tonnageData.profileList && this.tonnageData.profileList.length > 0) {
            for (const profileData of this.tonnageData.profileList) {
              if (profileLevel.data.arriveMnemonic.trim() === profileData.arriveMnemonic.trim() && profileLevel.data.departMnemonic.trim() === profileData.departMnemonic.trim()) {
                profileLevel.data.tonnageCapacity = Number(profileData.calculatedTonnageRating);
              }
            }
          }
          if (profileLevel.children && profileLevel.children.length > 0) {
            for (const gradeLevel of profileLevel.children) {
              gradeLevel.data.tonnageCapacity = this.profileLabel.blank;
              if (this.tonnageData && this.tonnageData.gradeList && this.tonnageData.gradeList.length > 0) {
                for (const gradeData of this.tonnageData.gradeList) {
                  if (gradeLevel.data.arriveMnemonic.trim() === gradeData.arriveMnemonic.trim() && gradeLevel.data.departMnemonic.trim() === gradeData.departMnemonic.trim()) {
                    gradeLevel.data.tonnageCapacity = Number(gradeData.calculatedTonnageRating);
                  }
                }
              }
            }
          }
        }
      }
    }
    this.lmsLoaderService.hideLoader();
  }
  /**
   * Error Method when calculated Tonnage throws error
   * @private
   * @memberof LmsTrainProfileComponent
   */
  private calculateTonnageError(error) {
    this.valuesToBeAddedInCalculation = this.valuesToBeAddedInCalculation.slice(0, -1);
    this.showCalculateTonnageCapacityHeader();
    this.calculatorHeading = this.calculatorHeading.substring(0, this.calculatorHeading.length - 2);
    this.lmsLoaderService.hideLoader();
    this.messageHandlerService.handleMessage(<MessageDetails>({
      type: this.configData.message.type.client,
      level: this.configData.message.level.error,
      target: this.configData.message.target.page,
      message: this.appUtilityService.getHttpErroMessage(error, false)
    }));
  }

  ngOnDestroy() {
    super.destroy();
  }

}
